// Team data — edit this file to add / update team members
export const TEAM = [
  {
    id: "hanniel-james",
    name: "Hanniél James",
    role: "Founder, Chief Executive Officer (CEO) & Trustee",
    shortRole: "Founder & CEO",
    number: "01",
    portrait: "/api/static/team/hanniel-placeholder.jpg",
    portraitLocal: true,
    portraitPlaceholder: true,
    quote:
      "Nguvu Ya Mwanamke was built on one belief — that a mother, well supported, changes everything for generations after her.",
    bio: "Hanniél founded Nguvu Ya Mwanamke Foundation to walk with the mothers she believed no system should leave behind. As CEO, she leads strategy, community and vision — turning conviction into circles, scholarships and second chances.",
    tags: ["Founder", "Vision", "Leadership"],
  },
  {
    id: "zarina-amir",
    name: "Zarina Amir",
    role: "Chair of Trustees",
    shortRole: "Chair of Trustees",
    number: "02",
    portrait: "/api/static/team/zarina.jpg",
    portraitLocal: true,
    quote:
      "A charity's promise is only as strong as the governance behind it — and ours will always be worthy of the mothers who trust us.",
    bio: "Zarina leads the board of trustees, oversees governance, chairs trustee meetings, and ensures the Foundation is well governed — holding the line so every mother we serve is met by an organisation that keeps its word.",
    tags: ["Governance", "Leadership", "Board Chair"],
  },
  {
    id: "swabrina-mbatta",
    name: "Swabrina Mbatta",
    role: "Finance Trustee / Treasurer",
    shortRole: "Finance Trustee",
    number: "03",
    portrait:
      "https://customer-assets.emergentagent.com/job_mwanamke-support/artifacts/ptprp5xz_IMG_1290.webp",
    quote:
      "Numbers, when handled with care, become fuel — for scholarships, for micro-grants, for a mother's second chance.",
    bio: "Swabrina safeguards the Foundation's finances with disciplined stewardship, translating every donation into measurable, mission-aligned outcomes for the mothers and children we serve.",
    tags: ["Stewardship", "Finance", "Trust"],
  },
  {
    id: "scholastica-fuad",
    name: "Scholastica Fuad",
    role: "Secretary & Trustee",
    shortRole: "Secretary & Trustee",
    number: "04",
    portrait:
      "https://customer-assets.emergentagent.com/job_mwanamke-support/artifacts/c4qw79r4_34ae54db-dbe6-496b-8b2a-e4d02bb4aeed.JPG",
    quote:
      "Every story deserves to be recorded — and every record, to move a mother one step closer to freedom.",
    bio: "Scholastica anchors the Foundation's operations and record-keeping, ensuring every commitment we make to a mother becomes a promise we keep in writing.",
    tags: ["Operations", "Advocacy", "Records"],
  },
];

export const TEAM_VALUES = [
  { label: "Stewardship", body: "Every shilling is accountable. Every promise is documented." },
  { label: "Sisterhood", body: "We lead in the same circles we serve." },
  { label: "Longevity", body: "We build for the mothers our mothers dreamed of." },
];
